<template>
  <div class="pageContainer">

    <div class="asideContainer" style="border-right: 8px solid whitesmoke">
      <div class="size">
        <div class="title">
          {{'成本价'}}
          <div class="space-between">
            <el-date-picker v-model="formData.year" @change="getCostPrice" format="YYYY 年" value-format="YYYY" :clearable="false" type="year" placeholder="年" style="width: 80px; margin-right: 10px" size="small"/>
            <el-select v-model="formData.material_no" @change="getCostPrice" placeholder="备品" clearable collapse-tags size="small" style="width: 200px; margin-right: 10px">
              <el-option
                  v-for="item in materialList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-loading="loading" element-loading-text="数据加载中" style="width: 470px;height: 300px" id="costPriceJgAccumulate"/>
      </div>

    </div>
  </div>

</template>

<script>
import * as echarts from "echarts";
export default {
  name: "EqHomePageJgZhiZao",
  data() {
    return {
      wuJianByYear:[],
      materialList:[],
      //成本价
      loading : false,
      formData:{
        year:this.$sysMethod.getCurrentYearByMonth().toString(),
        material_no: "",
        store_name: "加工仓库"
      },
      costPrice :{
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: ['1','2','3','4','5','6','7','8','9','10','11','12'],
          }
        ],
        yAxis: [
          {
            type: 'value'
          },
        ],
        series: [
          {
            name: '成本价',
            type: 'bar',
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      },

    }
  },
  methods: {

    async getCostPrice() {
      this.loading = true
      let {data: res} = await this.$axios.post('eq/homePage/getCostPrice',this.formData);
      if (res.code !== 0) {
        this.$message.error(res.message)

        this.loading = false
      }else {
        if (res.data) {
          this.costPrice.series[0].data = res.data.cost_price
        }
      }
      this.renderEcharts('costPriceJgAccumulate',this.costPrice)

      this.loading = false
    },


    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        //let _this = this
        /*let time
        //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/

      }
    },


    async getJgMaterial(){
      let {data: res} = await this.$axios.post('eq/homePage/getJgMaterial');
      if (res.code !== 0) {
        this.$message.error(res.message)
      }else {
        this.materialList = res.data
      }
    },


  },

  created(){
    this.getJgMaterial()
  },

  mounted() {
    this.getCostPrice()
  }
}
</script>

<style scoped>

.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
}

.asideContainer{
  width: 50%;
  height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.title{
  border-left: 3px solid steelblue;
  height: 25px;
  width: 80%;
  font-size: 16px;
  padding-left: 10px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}

.size{
  width: 100%;
  height: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

</style>